import {createContext} from "react";

const APIRequestHeader = createContext();

export default APIRequestHeader;